exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2UW0ST4gn6s7wis8wVLVkO{width:990px;margin:40px auto 40px auto}\n", ""]);

// Exports
exports.locals = {
	"orgChallenges": "_2UW0ST4gn6s7wis8wVLVkO"
};